<!--折线图配置 -->
<template>
  <div>
    <el-form-item label="图表样式"><el-select :value="settings.linePreset" aria-label="折线图样式" @input="setOption('linePreset', $event)"><el-option label="经典折线" value="classic" /><el-option label="科技面积" value="tech" /></el-select></el-form-item>
    <el-form-item label="竖展示">
      <avue-switch type="textarea"
                   v-model="main.activeOption.category"></avue-switch>
    </el-form-item>
    <template v-if="settings.linePreset === 'tech'">
      <p class="line-style-help">透明底的独立图表，可搭配组件标题和背景框；只改变外观，不改变设备数据与实时订阅。</p>
      <el-form-item v-for="field in colorFields" :key="field.key" :label="field.label"><div class="line-color-field"><el-input :value="colorInput(field.key)" :aria-label="'折线图' + field.label" @input="setOption(field.key, $event)" /><el-color-picker :value="settings[field.key]" show-alpha @change="setOption(field.key, $event || '')" /></div></el-form-item>
      <el-form-item label="平滑曲线"><el-switch :value="settings.lineSmooth" @input="setOption('lineSmooth', $event)" /></el-form-item>
      <el-form-item label="渐变面积"><el-switch :value="settings.lineFill" @input="setOption('lineFill', $event)" /></el-form-item>
      <el-form-item v-if="settings.lineFill" label="面积不透明度"><el-slider :value="settings.lineFillOpacity" :min="0" :max="1" :step="0.05" @input="setOption('lineFillOpacity', $event)" /></el-form-item>
      <el-form-item label="显示圆点"><el-switch :value="settings.linePoints" @input="setOption('linePoints', $event)" /></el-form-item>
      <el-form-item label="显示网格"><el-switch :value="settings.lineGrid" @input="setOption('lineGrid', $event)" /></el-form-item>
      <el-form-item label="线条宽度"><el-input-number :value="settings.techLineWidth" :min="1" :max="10" aria-label="科技折线宽度" @change="setOption('techLineWidth', $event)" /></el-form-item>
      <el-form-item v-if="settings.linePoints" label="圆点大小"><el-input-number :value="settings.techPointSize" :min="2" :max="20" aria-label="科技折线圆点大小" @change="setOption('techPointSize', $event)" /></el-form-item>
      <el-form-item label="纵轴单位／名称"><el-input :value="main.activeOption.yAxisName" maxlength="60" aria-label="科技折线纵轴单位或名称" placeholder="可选，如 A、kW" @input="setOption('yAxisName', $event)" /></el-form-item>
      <p v-if="main.activeOption.echartsOption !== undefined" class="line-style-help">已配置 ECharts Option，其中显式填写的样式优先。</p>
    </template>
    <el-collapse v-else accordion>
      <el-collapse-item title="折线设置">
        <el-form-item label="面积堆积">
          <avue-switch v-model="main.activeOption.areaStyle"></avue-switch>
        </el-form-item>
        <el-form-item label="线条宽度">
          <avue-slider v-model="main.activeOption.lineWidth">
          </avue-slider>
        </el-form-item>
        <el-form-item label="点的大小">
          <avue-slider v-model="main.activeOption.symbolSize">
          </avue-slider>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { linePresentationSettings } from '@/runtime/line-presentation'
export default {
  inject: ['main'],
  data: () => ({ colorFields: [{ key: 'lineAccentColor', label: '主曲线颜色' }, { key: 'lineSecondaryColor', label: '次曲线颜色' }, { key: 'lineGridColor', label: '网格颜色' }, { key: 'lineAxisColor', label: '轴线颜色' }, { key: 'lineTextColor', label: '文字颜色' }] }),
  computed: { settings () { return linePresentationSettings(this.main.activeOption) } },
  methods: {
    setOption (key, value) { this.$set(this.main.activeOption, key, value) },
    colorInput (key) { return typeof this.main.activeOption[key] === 'string' ? this.main.activeOption[key] : this.settings[key] }
  }
}
</script>

<style scoped>
.el-select, .el-input-number { width: 100%; }
.line-style-help { color: #a4b6c5; font-size: 12px; line-height: 1.6; margin: 0 0 12px; overflow-wrap: anywhere; }
.line-color-field { display: flex; gap: 6px; align-items: center; min-width: 0; }
.line-color-field .el-input { flex: 1; min-width: 0; }.line-color-field .el-color-picker { flex: none; }
</style>
